(function () {
  function initSixteenStep(root) {
    if (!root || root.dataset.sixteenStepInit === 'true') return;
    root.dataset.sixteenStepInit = 'true';

    var stages = root.querySelectorAll('.sixteen-step__stage');
    if (!stages.length) return;

    stages.forEach(function (stage) {
      stage.addEventListener('toggle', function () {
        if (!stage.open) return;
        stages.forEach(function (other) {
          if (other !== stage) other.open = false;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sixteen-step]').forEach(initSixteenStep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-sixteen-step]');
    if (section) initSixteenStep(section);
  });
})();
